import { render, staticRenderFns } from "./WareneinkaufEtw.vue?vue&type=template&id=4ec71e32&"
import script from "./WareneinkaufEtw.vue?vue&type=script&lang=ts&"
export * from "./WareneinkaufEtw.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports